import { render, staticRenderFns } from "./PPCThumbnail.vue?vue&type=template&id=b68ed462&"
import script from "./PPCThumbnail.vue?vue&type=script&lang=js&"
export * from "./PPCThumbnail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports